import { getArray } from '../lists/mergeArrays';
import { isEmptyArray } from '../objects/isEmpty';
import { normalizeValue } from './normalizeValue';
import { normalizeValues } from './normalizeValues';

export function safeJoin(parts: Array<string | undefined> | undefined, separator = ' '): string | undefined {
	const partsList = getArray(parts);
	const filtered = normalizeValues(partsList);

	if (isEmptyArray(filtered)) {
		return undefined;
	}

	const joined = filtered.join(separator);
	return normalizeValue(joined);
}
